/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramNameOnlyDto } from './program-name-only-dto';


export interface UserAccountGlobalDto { 
    accountEnabled?: boolean;
    agencyId?: string;
    agencyName?: string;
    email?: string;
    firstName?: string;
    id?: string;
    lastName?: string;
    oauthProvider?: string;
    phoneNumber?: string;
    programs?: Array<ProgramNameOnlyDto>;
    role?: UserAccountGlobalDto.RoleEnum;
    username?: string;
    version?: number;
}
export namespace UserAccountGlobalDto {
    export const RoleEnum = {
        RoleRootAdmin: 'ROLE_ROOT_ADMIN',
        RoleProgramAdmin: 'ROLE_PROGRAM_ADMIN',
        RoleProgramAll: 'ROLE_PROGRAM_ALL',
        RoleProgramAssigned: 'ROLE_PROGRAM_ASSIGNED'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


